import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  const [showBackTop, setShowBackTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowBackTop(window.scrollY > 500);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />
        <IndexSection />
        <AboutSection />
        <AppSection />
        <ContactSection />
        <MediaSection />
        <RankingSection />
        <UpdatesSection />
        <TopicsSection />
        <CardsSection />
        <CarouselSection />
        <FeaturesSection />
        <CommentsSection />
        <FaqSection />
      </main>

      <Footer />

      {showBackTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 transition-all z-40 cursor-pointer animate-[fadeIn_0.3s_ease]"
          aria-label="回到顶部"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </button>
      )}
    </div>
  );
}